import PropTypes from 'prop-types'

export default function InfoText({ children, italic = false }) {
  return <p className={`tw-text-sm ${italic ? 'tw-italic' : ''}`}>{children}</p>
}

InfoText.propTypes = {
  children: PropTypes.node,
  italic: PropTypes.bool,
}
